import React, { useState, useRef, useContext } from 'react'
// import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';



import Navbar from './components/Navbar.js';
import home from './pages/home.js';
import Game from './pages/ticTacToe.js';
import DayThree from './pages/thirdDaysOfReact/dayThree.js';
import ConditionalRendering from './pages/thirdDaysOfReact/conditionalRendering.js';
import JsxInDepth from './pages/jsxInDepth.js';
import clickableBoxes from './pages/threejs-fiber/clickableBox.js';
import basicExample from './pages/threejs-fiber/basicTJSExample.js';
import SparksEffects from './pages/threejs-fiber/sparks/index.js';

import { LanguageProvider } from './store/LanguageContext/LanguageContext.js';
// import LanguageSelector from './store/LanguageContext/LanguageSelectorButton.js';


import './styles.css'

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#33c9dc1',
      main: '#00bcd4',
      dark: '#008394',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff6333',
      main: '#ff3d00',
      dark: '#b22a00',
      contrastText: '#fff',
    }
  },
  typography: {
    useNextVariants: true,
  }
})

function App() {
 
  // const context = useContext(StateContext)

  return (
    <MuiThemeProvider theme={theme}>
      <LanguageProvider>
        <div className="App">
          <Router>
            <Navbar />
            <div className="container">
              <Switch>
                <Route exact path="/" component={home} />
                <Route exact path="/tic-tac-toe" component={Game} />
                <Route exact path="/day-three" component={DayThree} />
                <Route exact path="/conditional-rendering-in-react" component={ConditionalRendering} />
                <Route exact path="/jsx-in-depth" component={JsxInDepth} />
                <Route exact path="/3d-world" component={clickableBoxes} />
                <Route exact path="/basic-3d-example" component={basicExample} />
                <Route exact path="/sparks" component={SparksEffects} />
              </Switch>
            </div>
          </Router>
        </div>
      </LanguageProvider>  
  </MuiThemeProvider>
  )
}

export default App
